/* eslint-disable @typescript-eslint/no-explicit-any */
export const onUploading = (args: any, workspaceActions, modalStates) => {
  const params = {
    directory: workspaceActions?.directory,
    upload: modalStates.multiUpload.widgetData.upload
  };
  args.customFormData.push({ 'params': JSON.stringify(params) });
};